import { Box, CircularProgress, Grid2, Paper, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { DATA_SAVE_URL } from "../utils/UrlHandle";
import axios from "axios";
import Barcode from "react-barcode";
import { AuthContext } from "../loginform/AuthContext";
import { getPayload } from "../../services/api";
const InterlockReportView = ({
  isNonMobile,
  data,
  colors,
  onReportNoChange,
  letterHead,
}) => {
  const [mainData, setMainData] = useState({});
  const [loading, setLoading] = useState(true);
  const { loggedUser } = useContext(AuthContext);

  useEffect(() => {
    if (data.id !== undefined) {
      loadBasicData();
    }
    return () => loadBasicData();
  }, [data.id]);
  useEffect(() => {
    if (onReportNoChange && mainData.labRequest) {
      onReportNoChange(
        "QC/" +
          mainData.reportType +
          "/" +
          mainData.labRequest.year +
          "/" +
          String(mainData.reportTypeCount).padStart(4, "0")
      );
    }
  }, [
    mainData?.labRequest,
    mainData?.reportType,
    mainData?.id,
    onReportNoChange,
  ]);
  // console.log("main data", mainData);
  // console.log(" data", data);

  const loadBasicData = async () => {
    // console.log("basic data loaded");
    setLoading(true);

    await getPayload
      .getPayloadData("/dataForm/reportViewData/" + data.id)
      .then(function (response) {
        console.log("req data1111111", response.data);
        if (response.data !== null) {
          // console.log(response.data.labTestFormData);
          setMainData(response.data);
        }

        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  };

  return (
    <div>
      <Paper
        sx={{
          borderRadius: "8px",
          width: "210mm",
          padding: "20px",
        }}
        elevation={3}
      >
        {letterHead ? (
          <Box height="46.8mm"></Box>
        ) : (
          <Box display="flex" width="100%" justifyContent="center">
            <img
              alt="gove-logo"
              width="770mm"
              style={{ cursor: "pointer" }}
              src={`../../assets/Lhead.jpeg`}
            />
          </Box>
        )}

        <Box
          display="grid"
          gridTemplateColumns="repeat(12, minmax(0, 1fr))"
          sx={{
            "& > div": {
              gridColumn: isNonMobile ? undefined : "span 12",
            },
          }}
        >
          <Box sx={{ width: "200mm" }}>
            <Grid2 container>
              <Grid2
                size={12}
                display="flex"
                borderTop="black solid 2px"
                borderLeft="black solid 2px"
                borderRight="black solid 2px"
                padding="0px 5px 0px 5px"
                justifyContent="space-between"
              >
                <Box
                  alignContent="center"
                  borderRight="black solid 2px"
                  width="560px"
                >
                  <Typography
                    variant="h4"
                    textAlign="center"
                    sx={{
                      fontWeight: 700,
                      fontFamily: "Times New Roman",
                    }}
                  >
                    COMPRESSIVE STRENGTH TEST REPORT
                  </Typography>
                </Box>
                <Box
                  display="flex"
                  flexDirection="column-reverse"
                  justifyContent="center"
                  alignContent="center"
                >
                  <Barcode
                    value={mainData.barcode ? mainData.barcode : "-"}
                    width={1.4}
                    height={15}
                    displayValue={true}
                    fontSize={12}
                  />
                </Box>
              </Grid2>
              <Grid2 size={12}>
                <Grid2 container>
                  <Grid2
                    size={3}
                    border="black solid 2px"
                    alignContent="center"
                    paddingLeft="5px"
                    backgroundColor="lightgray"
                  >
                    <Typography
                      variant="h6"
                      component="h2"
                      sx={{
                        fontWeight: 700,
                        fontFamily: "Times New Roman",
                      }}
                    >
                      PROJECT
                    </Typography>
                  </Grid2>

                  <Grid2
                    size={6}
                    borderBottom="black solid 2px"
                    borderTop="black solid 2px"
                    borderRight="black solid 2px"
                    alignContent="center"
                    paddingLeft="5px"
                  >
                    <Typography
                      variant="h5"
                      component="h2"
                      sx={{
                        fontFamily: "Times New Roman",
                        fontStyle: "italic",
                      }}
                    >
                      {mainData.labRequest ? mainData.labRequest.project : ""}
                    </Typography>
                  </Grid2>
                  <Grid2
                    size={3}
                    textAlign="right"
                    borderTop="black solid 2px"
                    borderRight="black solid 2px"
                    alignContent="center"
                  >
                    <Typography
                      variant="h6"
                      alignContent="center"
                      sx={{
                        fontFamily: "Times New Roman",
                        backgroundColor: "lightgray",
                        borderBottom: "black solid 2px",
                        paddingRight: "2px",
                        paddingLeft: "2px",
                        fontWeight: "700",
                        height: "100%",
                      }}
                    >
                      {mainData.labRequest
                        ? "QC/" +
                          mainData.reportType +
                          "/" +
                          mainData.labRequest.year +
                          "/" +
                          String(mainData.reportTypeCount).padStart(4, "0")
                        : ""}
                    </Typography>
                  </Grid2>
                  <Grid2
                    size={3}
                    borderBottom="black solid 2px"
                    borderLeft="black solid 2px"
                    borderRight="black solid 2px"
                    alignContent="center"
                    backgroundColor="lightgray"
                  >
                    <Typography
                      variant="h6"
                      component="h2"
                      sx={{
                        fontWeight: 700,
                        fontFamily: "Times New Roman",
                        paddingLeft: "5px",
                      }}
                    >
                      INSTITUTE
                    </Typography>
                  </Grid2>

                  <Grid2
                    size={6}
                    borderBottom="black solid 2px"
                    borderRight="black solid 2px"
                    alignContent="center"
                  >
                    <Typography
                      variant="h5"
                      component="h2"
                      sx={{
                        fontFamily: "Times New Roman",
                        fontStyle: "italic",
                        textAlign: "justify",
                        paddingLeft: "5px",
                      }}
                    >
                      {mainData.institute
                        ? mainData.institute.instituteName
                        : ""}{" "}
                    </Typography>
                  </Grid2>
                  <Grid2 size={3} textAlign="right" alignContent="center">
                    <Typography
                      variant="h6"
                      component="h2"
                      backgroundColor="lightgray"
                      sx={{
                        fontFamily: "Times New Roman",
                        paddingRight: "5px",
                        borderBottom: "black solid 2px",
                        borderRight: "black solid 2px",
                        fontWeight: 700,
                        height: "100%",
                      }}
                    >
                      JOB NO :{" "}
                      {data?.labRequest.year +
                        "/" +
                        String(data.labRequest.id).padStart(4, "0")}
                    </Typography>
                  </Grid2>

                  <Grid2
                    size={3}
                    borderBottom="black solid 2px"
                    alignContent="center"
                    borderLeft="black solid 2px"
                    borderRight="black solid 2px"
                    backgroundColor="lightgray"
                  >
                    <Typography
                      variant="h6"
                      component="h2"
                      sx={{
                        fontWeight: 700,
                        fontFamily: "Times New Roman",
                        paddingLeft: "5px",
                      }}
                    >
                      REFERENCE
                    </Typography>
                  </Grid2>
                  <Grid2
                    size={6}
                    alignContent="center"
                    borderBottom="black solid 2px"
                    borderRight="black solid 2px"
                  >
                    <Typography
                      variant="h5"
                      component="h2"
                      sx={{
                        fontFamily: "Times New Roman",
                        fontStyle: "italic",
                        paddingLeft: "5px",
                      }}
                    >
                      {mainData.reference}
                    </Typography>
                  </Grid2>
                  <Grid2 size={3} textAlign="right" alignContent="center">
                    <Typography
                      variant="h6"
                      component="h2"
                      backgroundColor="lightgray"
                      sx={{
                        fontFamily: "Times New Roman",
                        paddingRight: "5px",
                        borderBottom: "black solid 2px",
                        borderRight: "black solid 2px",
                        height: "100%",
                        fontWeight: 700,
                      }}
                    >
                      DATE : {mainData.date}
                    </Typography>
                  </Grid2>
                  <Grid2
                    size={3}
                    borderBottom="black solid 2px"
                    borderLeft="black solid 2px"
                    borderRight="black solid 2px"
                    backgroundColor="lightgray"
                  >
                    <Typography
                      variant="h6"
                      component="h2"
                      sx={{
                        fontWeight: 700,
                        fontFamily: "Times New Roman",
                        paddingLeft: "5px",
                      }}
                    >
                      SAMPLE LOCATION
                    </Typography>
                  </Grid2>
                  <Grid2
                    size={6}
                    borderBottom="black solid 2px"
                    borderRight="black solid 2px"
                  >
                    <Typography
                      variant="h5"
                      component="h2"
                      sx={{
                        fontFamily: "Times New Roman",
                        fontStyle: "italic",
                        paddingLeft: "5px",
                      }}
                    >
                      {mainData.sampleLocation}
                    </Typography>
                  </Grid2>
                  <Grid2 size={3} textAlign="right">
                    <Typography
                      variant="h6"
                      component="h2"
                      backgroundColor="lightgray"
                      sx={{
                        fontFamily: "Times New Roman",
                        paddingRight: "5px",
                        borderBottom: "black solid 2px",
                        borderRight: "black solid 2px",
                        height: "100%",
                        fontWeight: 700,
                      }}
                    >
                      {`ISSUED ON : ${
                        mainData.finalizeDate
                          ? mainData.finalizeDate
                          : "Pending"
                      }`}
                    </Typography>
                  </Grid2>
                </Grid2>
              </Grid2>
            </Grid2>
          </Box>

          <Box
            sx={{
              gridColumn: "span 12",
              borderLeft: "black solid 2px",
              borderRight: "black solid 2px",
              borderBottom: "black solid 2px",
              width: "756px",
            }}
            justifyItems="center"
          >
            <Typography
              variant="h4"
              textAlign="center"
              sx={{
                fontWeight: 700,
                fontFamily: "Times New Roman",
              }}
            >
              TESTING OF INTERLOCK PAVING
            </Typography>
          </Box>
          {/* <Box
            display="flex"
            border="black solid 2px"
            sx={{
              gridColumn: "span 12",
              width: "756px",
            }}
          >
            <Typography
              variant="h5"
              textAlign="center"
              alignContent="center"
              sx={{
                fontWeight: 700,
                fontFamily: "Times New Roman",
                width: "375px",
                borderRight: "black solid 2px",
                backgroundColor: "lightgray",
              }}
            >
              {mainData.testDays ? mainData.testDays : ""} DAYS STRENGTH
            </Typography>
            <Box display="flex">
              <Box justifyItems="left" width="188px">
                <Typography
                  variant="h5"
                  textAlign="center"
                  sx={{
                    fontWeight: 700,
                    width: "100%",
                    fontFamily: "Times New Roman",
                    backgroundColor: "lightgray",
                    borderBottom: "black solid 2px",
                    borderRight: "black solid 2px",
                  }}
                >
                  CEMENT
                </Typography>
                <Typography
                  variant="h5"
                  textAlign="center"
                  sx={{
                    fontWeight: 700,
                    width: "100%",
                    fontFamily: "Times New Roman",
                    backgroundColor: "lightgray",
                    borderRight: "black solid 2px",
                  }}
                >
                  GRADE
                </Typography>
              </Box>
              <Box>
                <Typography
                  variant="h5"
                  component="h2"
                  borderBottom="black solid 2px"
                  textAlign="center"
                  sx={{
                    width: "187px",
                    fontFamily: "Times New Roman",
                    fontStyle: "italic",
                  }}
                >
                  {mainData.cement ? mainData.cement : "-"}
                </Typography>
                <Typography
                  variant="h5"
                  component="h2"
                  textAlign="center"
                  sx={{
                    fontFamily: "Times New Roman",
                    fontStyle: "italic",
                  }}
                >
                  {mainData.grade?.includes("(")
                    ? mainData.grade.split("(")[1].replace(")", "")
                    : mainData.grade}
                </Typography>
              </Box>
            </Box>
          </Box> */}
          <Typography
            textAlign="center"
            variant="subtitle2"
            alignContent="center"
            borderLeft="black solid 2px"
            borderRight="black solid 2px"
            borderBottom="black solid 2px"
            sx={{
              gridColumn: "span 2",
              fontWeight: 700,
              fontFamily: "Times New Roman",
            }}
          >
            Serial No.
          </Typography>
          <Typography
            textAlign="center"
            variant="subtitle2"
            alignContent="center"
            borderRight="black solid 2px"
            borderBottom="black solid 2px"
            sx={{
              gridColumn: "span 2",
              fontWeight: 700,
              fontFamily: "Times New Roman",
            }}
          >
            Date of cast
          </Typography>
          <Typography
            textAlign="center"
            variant="subtitle2"
            alignContent="center"
            borderRight="black solid 2px"
            borderBottom="black solid 2px"
            sx={{
              gridColumn: "span 2",
              fontWeight: 700,
              fontFamily: "Times New Roman",
            }}
          >
            Date of test
          </Typography>
          <Typography
            textAlign="center"
            variant="subtitle2"
            alignContent="center"
            borderRight="black solid 2px"
            borderBottom="black solid 2px"
            sx={{
              gridColumn: "span 1",
              fontWeight: 700,
              fontFamily: "Times New Roman",
            }}
          >
            Height (mm)
          </Typography>
          <Typography
            textAlign="center"
            variant="subtitle2"
            alignContent="center"
            borderRight="black solid 2px"
            borderBottom="black solid 2px"
            sx={{
              gridColumn: "span 2",
              fontWeight: 700,
              fontFamily: "Times New Roman",
            }}
          >
            Effective Area of cube (mm²)
          </Typography>
          <Typography
            textAlign="center"
            variant="subtitle2"
            alignContent="center"
            borderRight="black solid 2px"
            borderBottom="black solid 2px"
            sx={{
              gridColumn: "span 1",
              fontWeight: 700,
              fontFamily: "Times New Roman",
            }}
          >
            Load (kN)
          </Typography>

          <Typography
            textAlign="center"
            variant="subtitle2"
            alignContent="center"
            borderRight="black solid 2px"
            borderBottom="black solid 2px"
            sx={{
              gridColumn: "span 2",
              fontWeight: 700,
              fontFamily: "Times New Roman",
              width: "128px",
            }}
          >
            Compressive strength (N/mm²)
          </Typography>

          {mainData.labTestsDataFromSubs?.map((data, index) => (
            <>
              <Typography
                textAlign="center"
                variant="subtitle1"
                alignContent="center"
                borderRight="black solid 2px"
                borderLeft="black solid 2px"
                borderBottom="black solid 2px"
                sx={{
                  gridColumn: "span 2",
                  fontFamily: "Times New Roman",
                  padding: "3px",
                }}
              >
                {data.id === undefined
                  ? "AUTO"
                  : String(data.serialNo).padStart(3, "0") + data.color
                  ? data.color === "" || data.color === "None"
                    ? String(data.serialNo).padStart(3, "0")
                    : " (" + data.color + ")"
                  : ""}
              </Typography>
              <Typography
                textAlign="center"
                variant="subtitle1"
                alignContent="center"
                borderRight="black solid 2px"
                borderBottom="black solid 2px"
                sx={{
                  gridColumn: "span 2",
                  fontFamily: "Times New Roman",
                }}
              >
                {mainData.showDateOfCast
                  ? mainData.dateOfCast
                  : "NOT INTIMATED"}
              </Typography>
              <Typography
                textAlign="center"
                variant="subtitle1"
                alignContent="center"
                borderRight="black solid 2px"
                borderBottom="black solid 2px"
                sx={{
                  gridColumn: "span 2",
                  fontFamily: "Times New Roman",
                }}
              >
                {mainData.dateOfTest}
              </Typography>
              <Typography
                textAlign="center"
                variant="subtitle1"
                borderRight="black solid 2px"
                borderBottom="black solid 2px"
                alignContent="center"
                sx={{
                  gridColumn: "span 1",
                  fontFamily: "Times New Roman",
                }}
              >
                {mainData.height}
              </Typography>
              <Typography
                textAlign="center"
                variant="subtitle1"
                alignContent="center"
                borderRight="black solid 2px"
                borderBottom="black solid 2px"
                sx={{
                  gridColumn: "span 2",
                  fontFamily: "Times New Roman",
                }}
              >
                {mainData.areaOfCube}
              </Typography>
              <Typography
                textAlign="center"
                variant="subtitle1"
                borderRight="black solid 2px"
                borderBottom="black solid 2px"
                alignContent="center"
                sx={{
                  gridColumn: "span 1",
                  fontFamily: "Times New Roman",
                }}
              >
                {data.weight}
              </Typography>
              <Typography
                textAlign="center"
                variant="subtitle1"
                alignContent="center"
                borderRight="black solid 2px"
                borderBottom="black solid 2px"
                sx={{
                  gridColumn: "span 2",
                  fontFamily: "Times New Roman",
                  width: "128px",
                }}
              >
                {data.compressiveStrength?.toFixed(2)}
              </Typography>
            </>
          ))}
        </Box>

        {loading ? (
          <CircularProgress
            sx={{
              marginLeft: "40%",
              color: colors.greenAccent[500],
              position: "absolute",
              zIndex: 10,
            }}
          />
        ) : (
          ""
        )}
        <Box justifyItems="center" width="756px">
          {mainData?.labRequestTests?.checkedByEngineer === true ? (
            loggedUser?.id ? (
              ""
            ) : (
              <Paper
                sx={{
                  position: "relative",
                  "&::before": {
                    content: "'VERIFIED COPY'",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%) rotate(-15deg)",
                    fontSize: "5rem",
                    fontWeight: "bold",
                    color: "rgba(138, 138, 138, 0.5)",
                    zIndex: 0,
                    pointerEvents: "none",
                    whiteSpace: "nowrap",
                  },
                }}
              ></Paper>
            )
          ) : (
            <Paper
              sx={{
                position: "relative",
                "&::before": {
                  content: "'UNAUTHORIZED'",
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%) rotate(-15deg)",
                  fontSize: "5rem",
                  fontWeight: "bold",
                  color: "rgba(255, 67, 67, 0.5)",
                  zIndex: 0,
                  pointerEvents: "none",
                  whiteSpace: "nowrap",
                },
              }}
            ></Paper>
          )}
        </Box>

        <Box
          display="grid"
          width="756px"
          gridTemplateColumns="repeat(1, minmax(0, 1fr))"
          borderBottom="black solid 2px"
          borderLeft="black solid 2px"
          borderRight="black solid 2px"
          textAlign="center"
        >
          <Box display="flex" flexDirection="row">
            <Typography
              textAlign="left"
              variant="h6"
              alignContent="left"
              borderBottom="black solid 2px"
              sx={{
                gridColumn: "span 1",
                marginTop: "2px",
                fontWeight: 600,
                paddingLeft: "5px",
                fontFamily: "Times New Roman",
              }}
            >
              Note:
            </Typography>
            <Typography
              textAlign="left"
              variant="h6"
              alignContent="left"
              borderBottom="black solid 2px"
              sx={{
                gridColumn: "span 1",
                marginTop: "2px",
                fontWeight: 500,
                paddingLeft: "5px",
                fontStyle: "Italic",
                fontFamily: "Times New Roman",
              }}
            >
              {mainData.specialNote ? mainData.specialNote : "N/A"}
            </Typography>
          </Box>
          <Typography
            textAlign="left"
            variant="h6"
            alignContent="left"
            sx={{
              gridColumn: "span 1",
              marginTop: "2px",
              fontWeight: 500,
              paddingLeft: "5px",
              fontFamily: "Times New Roman",
            }}
          >
            Remarks : {mainData.remarks ? mainData.remarks : "N/A"}
          </Typography>
        </Box>

        <Box
          borderLeft="black solid 2px"
          width="756px"
          borderRight="black solid 2px"
        >
          <Grid2 container>
            <Grid2 size={6} borderBottom="black solid 2px">
              <Box display="flex">
                <Typography
                  textAlign="left"
                  variant="h6"
                  component="h2"
                  sx={{
                    fontWeight: 700,
                    width: "150px",
                    fontFamily: "Times New Roman",
                    backgroundColor: "lightgray",
                    borderRight: "black solid 2px",
                    alignContent: "center",
                    padding: "2px",
                  }}
                >
                  SAMPLE TAKEN BY
                </Typography>

                <Typography
                  variant="h5"
                  component="h2"
                  sx={{
                    fontFamily: "Times New Roman",
                    fontStyle: "italic",
                    alignContent: "center",
                    padding: "2px",
                    width: "150px",
                  }}
                >
                  {mainData.sampleTakenBy}
                </Typography>
              </Box>
              <Box display="flex" borderTop="black solid 2px">
                <Typography
                  textAlign="left"
                  variant="h6"
                  component="h2"
                  sx={{
                    fontWeight: 700,
                    width: "150px",
                    padding: "2px",
                    fontFamily: "Times New Roman",
                    backgroundColor: "lightgray",
                    borderRight: "black solid 2px",
                    alignContent: "center",
                  }}
                >
                  TESTED BY
                </Typography>

                <Typography
                  variant="h5"
                  component="h2"
                  sx={{
                    fontFamily: "Times New Roman",
                    fontStyle: "italic",
                    padding: "2px",
                    alignContent: "center",
                  }}
                >
                  {mainData.testedBy?.firstName +
                    " " +
                    mainData.testedBy?.lastName}
                  <br />
                  {"(" + mainData.testedBy?.position.position + ")"}
                </Typography>
              </Box>
              <Box
                display="flex"
                borderBottom="black solid 2px"
                borderTop="black solid 2px"
              >
                <Typography
                  textAlign="left"
                  variant="h6"
                  component="h2"
                  sx={{
                    fontWeight: 700,
                    width: "150px",
                    fontFamily: "Times New Roman",
                    padding: "2px",
                    backgroundColor: "lightgray",
                    borderRight: "black solid 2px",
                    alignContent: "center",
                  }}
                >
                  REPORTED BY
                </Typography>

                <Typography
                  variant="h5"
                  component="h2"
                  sx={{
                    fontFamily: "Times New Roman",
                    fontStyle: "italic",
                    padding: "2px",
                    alignContent: "center",
                  }}
                >
                  {mainData.reportedBy?.firstName +
                    " " +
                    mainData.reportedBy?.lastName}
                  <br />
                  {" (" + mainData.reportedBy?.position.position + ")"}
                  <br />
                  {mainData.reportedBy?.qualifications}
                </Typography>
              </Box>
              <Box display="flex">
                <Typography
                  textAlign="justify"
                  variant="h6"
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    marginTop: "10px",
                    fontFamily: "Times New Roman",
                    paddingLeft: "5px",
                    paddingRight: "5px",
                  }}
                >
                  <strong sx={{ fontFamily: "Times New Roman" }}>
                    AUTHENTICITY :
                  </strong>{" "}
                  This document is issued free of alterations of any form,
                  inclusive of strikethrough ,erasure, masking and overtyping.
                  Altering the contents of the report is an Offence, and it
                  further makes the document void.
                </Typography>
              </Box>
            </Grid2>
            <Grid2
              size={6}
              borderBottom="black solid 2px"
              borderLeft="black solid 2px"
            >
              <Box>
                <Typography
                  textAlign="center"
                  variant="h5"
                  component="h2"
                  borderBottom="black solid 2px"
                  sx={{
                    width: "100%",
                    paddingBottom: "5px",
                    fontWeight: 700,
                    fontFamily: "Times New Roman",
                    backgroundColor: "lightgrey",
                  }}
                >
                  AUTHORIZED SIGNATORY
                </Typography>
                <Box display="flex" justifyContent="center">
                  {mainData.labRequestTests?.checkedByEngineer ? (
                    <Box>
                      <Typography
                        textAlign="center"
                        variant="h6"
                        alignContent="center"
                        sx={{
                          gridColumn: "span 1",
                          fontWeight: 700,
                        }}
                      >
                        {letterHead ? (
                          <Box
                            display="flex"
                            width="220px"
                            height="120px"
                            justifyContent="center"
                          ></Box>
                        ) : (
                          <Box display="flex" justifyContent="center">
                            <img
                              alt="gove-logo"
                              width="220px"
                              height="120px"
                              style={{ cursor: "pointer" }}
                              src={`../../assets/signature.png`}
                            />
                          </Box>
                        )}
                      </Typography>
                      {letterHead ? (
                        ""
                      ) : (
                        <Typography
                          textAlign="left"
                          variant="subtitle1"
                          alignContent="center"
                          paddingLeft="10px"
                          fontWeight={700}
                          color="error"
                          sx={{
                            gridColumn: "span 1",
                            fontFamily: "Times New Roman",
                          }}
                        >
                          DIGITALLY SIGNED ON{" "}
                          {mainData?.labRequestTests?.finalizedDateTime
                            ? mainData?.labRequestTests?.finalizedDateTime.replace(
                                "T",
                                " "
                              )
                            : "-"}
                          BY,
                        </Typography>
                      )}

                      <Typography
                        textAlign="left"
                        paddingLeft="10px"
                        variant="h6"
                        alignContent="center"
                        sx={{
                          gridColumn: "span 1",
                          fontFamily: "Times New Roman",
                          fontWeight: "600",
                        }}
                      >
                        Eng. E.M.S.M.K Ekanayake
                      </Typography>
                      <Typography
                        textAlign="left"
                        variant="h6"
                        alignContent="center"
                        paddingLeft="10px"
                        sx={{
                          gridColumn: "span 1",
                          fontWeight: 100,
                          fontFamily: "Times New Roman",
                          fontStyle: "italic",
                        }}
                      >
                        BEng,MSc,MBA,CEng,MIE(SL),GMICE(UK),M-8666
                      </Typography>
                      <Typography
                        textAlign="left"
                        variant="h6"
                        alignContent="center"
                        paddingLeft="10px"
                        sx={{
                          gridColumn: "span 1",
                          fontWeight: 100,
                          fontFamily: "Times New Roman",
                        }}
                      >
                        Engineer (Quality Control)
                      </Typography>
                    </Box>
                  ) : (
                    ""
                  )}
                </Box>
              </Box>
            </Grid2>
          </Grid2>
        </Box>
        <Box
          display="grid"
          width="756px"
          gridTemplateColumns="repeat(1, minmax(0, 1fr))"
          borderRight="black solid 2px"
          borderLeft="black solid 2px"
          textAlign="center"
        >
          <Box
            display="flex"
            borderBottom="black solid 2px"
            justifyContent="center"
          >
            <Typography
              textAlign="center"
              variant="h6"
              alignContent="left"
              sx={{
                gridColumn: "span 1",
                marginTop: "2px",
                paddingLeft: "5px",
                fontFamily: "Times New Roman",
                fontSize: "14px",
                fontWeight: "600",
              }}
            >
              Visit
            </Typography>
            <Typography
              textAlign="center"
              variant="h6"
              alignContent="left"
              color="info"
              sx={{
                gridColumn: "span 1",
                marginTop: "2px",
                paddingLeft: "5px",
                fontFamily: "Times New Roman",
                fontSize: "14px",
                fontWeight: "600",
              }}
            >
              matlab.lk
            </Typography>
            <Typography
              textAlign="center"
              variant="h6"
              alignContent="left"
              sx={{
                gridColumn: "span 1",
                marginTop: "2px",
                paddingLeft: "5px",
                fontFamily: "Times New Roman",
                fontSize: "14px",
                fontWeight: "600",
              }}
            >
              and use this code
            </Typography>
            <Typography
              textAlign="center"
              variant="h6"
              alignContent="left"
              color="info"
              sx={{
                gridColumn: "span 1",
                marginTop: "2px",
                paddingLeft: "5px",
                fontFamily: "Times New Roman",
                fontSize: "14px",
                fontWeight: "600",
              }}
            >
              {mainData.barcode ? mainData.barcode : "-"}
            </Typography>
            <Typography
              textAlign="center"
              variant="h6"
              alignContent="left"
              sx={{
                gridColumn: "span 1",
                marginTop: "2px",
                paddingLeft: "5px",
                fontFamily: "Times New Roman",
                fontSize: "14px",
                fontWeight: "600",
              }}
            >
              to download the verified copy.
            </Typography>
          </Box>
        </Box>
        <Box
          display="grid"
          width="756px"
          gridTemplateColumns="repeat(1, minmax(0, 1fr))"
          borderRight="black solid 2px"
          borderLeft="black solid 2px"
          textAlign="center"
          backgroundColor="lightgrey"
        >
          <Typography
            textAlign="center"
            variant="h5"
            alignContent="left"
            borderBottom="black solid 2px"
            sx={{
              gridColumn: "span 1",
              marginTop: "2px",
              fontWeight: 600,
              paddingLeft: "5px",
              fontFamily: "Times New Roman",
            }}
          >
            END OF REPORT - THIS IS A COMPUTER GENERATED DOCUMENT.
          </Typography>
        </Box>
      </Paper>
    </div>
  );
};

export default InterlockReportView;
